import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function PhotoFill({
  color = 'icon.primary',
  fill = 'transparent',
  strokeWidth = '1.5',
  ...props
}) {
  const isDefaultFill = fill === 'transparent'

  return (
    <IconBase viewBox='0 0 22 18' {...props}>
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.3358 4.55589L14.7147 1.86097C14.393 1.32646 13.8153 1 13.1912 1H8.76472C8.13259
         1 7.54848 1.33607 7.23002 1.88177L5.66811 4.55589H3.22283C1.99539 4.55589 1 5.55129
          1 6.77873V14.7803C1 16.0077 1.99539 17.0031 3.22283 17.0031H18.7811C20.0085 17.0031
           21.0039 16.0077 21.0039 14.7803V6.77873C21.0039 5.55129 20.0085 4.55589 18.7827 4.55589H16.3358Z'
        fill={fill}
        stroke={isDefaultFill ? color : 'none'}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={strokeWidth}
      />
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.2728 7.68562C14.4874 8.90025 14.4874 10.8718 13.2728 12.0865C12.0581 13.3011
         10.0866 13.3011 8.87192 12.0865C7.65728 10.8718 7.65728 8.90025 8.87192 7.68562C10.0882
          6.46938 12.0581 6.46938 13.2728 7.68562Z'
        fill={fill}
        stroke={!isDefaultFill ? 'none' : color}
        strokeWidth={strokeWidth}
      />
      <Path
        d='M13.2728 7.68562C14.4874 8.90025 14.4874 10.8718 13.2728 12.0865C12.0581 13.3011
         10.0866 13.3011 8.87192 12.0865C7.65728 10.8718 7.65728 8.90025 8.87192 7.68562C10.0882
          6.46938 12.0581 6.46938 13.2728 7.68562'
        fill={!isDefaultFill ? 'white' : fill}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={strokeWidth}
      />
    </IconBase>
  )
}

PhotoFill.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
  strokeWidth: PropTypes.string,
}

export default PhotoFill
